module.exports = __webpack_public_path__ + "img/img-cover-default.a483e350.png";